import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ title, description, keywords, canonical, ogImage, ogType, twitterHandle, schema, noindex }) => {
    const siteName = 'MehareTech';
    const siteUrl = 'https://meharetech.com';
    const fullTitle = title?.includes('MehareTech') ? title : `${title} | ${siteName}`;
    const defaultDescription = 'MehareTech is a premier IT Services & Software Development company. We engineer high-performance websites, mobile apps, cloud solutions, and digital marketing strategies since 2012.';
    const defaultKeywords = 'MehareTech, IT services India, website development company, Android app development, React developers, digital marketing agency, SEO services, cloud solutions, cyber security';
    const defaultImage = `${siteUrl}/images/logo-meharetech.png`;

    const canonicalUrl = canonical || (typeof window !== 'undefined' ? window.location.href : siteUrl);
    const imageUrl = ogImage || defaultImage;

    return (
        <Helmet>
            {/* Essential Meta Tags */}
            <html lang="en" />
            <title>{fullTitle}</title>
            <meta name="description" content={description || defaultDescription} />
            <meta name="keywords" content={keywords || defaultKeywords} />
            <meta name="author" content="MehareTech Solutions" />
            <meta name="robots" content={noindex ? "noindex, nofollow" : "index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"} />
            <link rel="canonical" href={canonicalUrl} />

            {/* Viewport & Mobile Optimization */}
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=5.0" />
            <meta name="theme-color" content="#8B5CF6" />
            <meta name="mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-capable" content="yes" />
            <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent" />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={ogType || 'website'} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description || defaultDescription} />
            <meta property="og:image" content={imageUrl} />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="630" />
            <meta property="og:site_name" content={siteName} />
            <meta property="og:locale" content="en_US" />

            {/* Twitter Card */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={canonicalUrl} />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description || defaultDescription} />
            <meta name="twitter:image" content={imageUrl} />
            <meta name="twitter:creator" content={twitterHandle || '@meharetech'} />
            <meta name="twitter:site" content="@meharetech" />

            {/* Additional SEO Tags */}
            <meta name="rating" content="general" />
            <meta name="distribution" content="global" />
            <meta name="revisit-after" content="7 days" />
            <meta httpEquiv="X-UA-Compatible" content="IE=edge" />

            {/* Geo Tags for Local SEO */}
            <meta name="geo.region" content="IN-HR" />
            <meta name="geo.placename" content="Hisar, Haryana" />
            <meta name="geo.position" content="29.1492;75.7217" />
            <meta name="ICBM" content="29.1492, 75.7217" />

            {/* JSON-LD Structured Data */}
            {schema && (
                <script type="application/ld+json">
                    {JSON.stringify(Array.isArray(schema) ? schema : [schema])}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
